/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BusinessObjectFormatDdl } from './businessObjectFormatDdl';


export interface BusinessObjectFormatDdlCollectionResponse { 
    /**
     * A container for the Business Object Format responses
     */
    businessObjectFormatDdlResponses?: Array<BusinessObjectFormatDdl>;
    /**
     * A container for the combined DDL for all Business Object Formats in the collection
     */
    ddlCollection: string;
}
